import { queryOptions } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { indexOrdersQuotaConsumers } from "~/modules/project/api/order/orderApiDispatchers.ts";
import {
	indexAvailableQuotaConsumersByCompany,
	indexEligibleQuotaInvoices,
	indexQuotaConsumers,
	indexQuotas,
	indexQuotasByCompanyId,
	showQuota,
} from "~/modules/quota/api/quota/quotaApiDispatchers.ts";

export const quotaQueries = {
	baseKey: ["quota"],
	availableConsumers: (companyId: string) =>
		queryOptions({
			queryKey: [...quotaQueries.baseKey, companyId, "available-consumers"],
			queryFn: () => indexAvailableQuotaConsumersByCompany(companyId).then(getDataFromResponse),
			enabled: !!companyId,
		}),
	// The key is below baseKey, so invalidateQuotaQueries() also reloads the quota tab of an order.
	byOrder: (projectId: string, orderId: string) =>
		queryOptions({
			queryKey: [...quotaQueries.baseKey, "order", orderId, "consumers"],
			queryFn: () => indexOrdersQuotaConsumers(projectId, orderId).then(getDataFromResponse),
			enabled: !!projectId && !!orderId,
		}),
	consumers: (companyId: string, quotaId: string) =>
		queryOptions({
			queryKey: [...quotaQueries.baseKey, quotaId, "consumers"],
			queryFn: () => indexQuotaConsumers(companyId, quotaId).then(getDataFromResponse),
			enabled: !!companyId && !!quotaId,
		}),
	details: (companyId: string, quotaId: string, withRelations?: boolean) =>
		queryOptions({
			queryKey: [...quotaQueries.baseKey, "details", quotaId, withRelations],
			queryFn: () => showQuota(companyId, quotaId, withRelations).then(getDataFromResponse),
			enabled: !!companyId && !!quotaId,
		}),
	eligibleInvoices: (companyId: string) =>
		queryOptions({
			queryKey: [...quotaQueries.baseKey, companyId, "eligible-invoices"],
			queryFn: () => indexEligibleQuotaInvoices(companyId).then(getDataFromResponse),
			enabled: !!companyId,
		}),
	index: () => queryOptions({
		queryKey: [...quotaQueries.baseKey, "index"],
		queryFn: () => indexQuotas().then(getDataFromResponse),
	}),
	indexByCompany: (companyId: string) => queryOptions({
		queryKey: [...quotaQueries.baseKey, companyId, "indexByCompany"],
		queryFn: () => indexQuotasByCompanyId(companyId).then(getDataFromResponse),
		enabled: !!companyId,
	}),
};